
import { PaymentServices } from '@/services/payment.services'
import { MemberBankServices } from '@/services/memberbank.services'

const state = {
  loading: false,
  dialogtopupsaldo: false,
  dialogcashout: false,
  dialogaddbank: false,
  dialog: false,
  overlay: false,
  kodepromo: [],
  totalkodepromo: 0,
  paymenthistories: [],
  paymenthistoriesdownload: [],
  totalpaymenthistori: 0,
  mutasisaldo: [],
  mutasisaldodownload: [],
  totalmutasisaldo: 0,
  tiketdepositresponse: {},
  invoiceccresponse: {},
  paymentmethod: [],
  jmltopup: 0,
  memberbanks: [],
  otpkey: '',
  bankavailablecashout: {
    ready: false,
    banks: []
  }
}
const actions = {
  cleardata ({ commit }) {
    commit('cleardata')
  },
  setjmltopup ({ commit }, data) {
    commit('setjmltopup', data)
  },
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setdialogaddbank ({ commit }, diag) {
    commit('setdialogaddbank', diag)
  },
  setdialogtopupsaldo ({ commit }, diag) {
    commit('setdialogtopupsaldo', diag)
  },
  setdialogcashout ({ commit }, diag) {
    commit('setdialogcashout', diag)
    commit('cleardata', diag)
  },
  getInvoiceCC ({ dispatch, commit }, opt) {
    commit('setloading', true)
    PaymentServices.getInvoiceCC(opt).then(value => {
      commit('setloading', false)
      window.getApp.$emit('INVOICE_CC_RESP', value)
      commit('setinvoiceresponse', value)
    }).catch(reason => {
      console.log(reason)
      if (reason.includes('Duplicate')) {
        dispatch('alert/error', 'Ulangi Gunakan Nominal Lain', { root: true })
      }
      commit('setloading', false)
    })
  },
  getTiketDeposit ({ commit }, opt) {
    commit('setloading', true)
    PaymentServices.tiketdeposit(opt).then(value => {
      commit('setloading', false)
      window.getApp.$emit('CONF_DEPOSIT', value)
      commit('settiketdepositresp', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getPaymentmethod ({ commit }) {
    commit('setloading', true)
    PaymentServices.getPaymentmethod().then(value => {
      commit('setloading', false)
      commit('setpaymentmethod', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getPaymentHistories ({ commit }, opt) {
    commit('setloading', true)
    PaymentServices.getPaymentHistories(opt).then(value => {
      commit('setloading', false)
      commit('setpaymenthistories', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getPaymentHistoriesDownload ({ commit }, opt) {
    commit('setloading', true)
    PaymentServices.getPaymentHistoriDownload(opt).then(value => {
      commit('setloading', false)
      commit('setpaymenthistoriesdownload', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getMutasiSaldo ({ commit }, opt) {
    commit('setloading', true)
    PaymentServices.getMutasiSaldo(opt).then(value => {
      commit('setloading', false)
      commit('setmutasisaldo', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getMutasiSaldoDownload ({ commit }, opt) {
    commit('setloading', true)
    PaymentServices.getMutasiSaldoDownload(opt).then(value => {
      commit('setloading', false)
      commit('setmutasisaldodownload', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getMemberBanks ({ commit }) {
    commit('setloading', true)
    MemberBankServices.getMemberBanks().then(value => {
      commit('setloading', false)
      commit('setmemberbank', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  addMemberBank ({ dispatch, commit }, data) {
    commit('setloading', true)
    MemberBankServices.addMemberbanks(data).then(value => {
      commit('setloading', false)
      commit('setdialogaddbank', false)
      dispatch('alert/success', 'Add Bank Ok!', { root: true })
      MemberBankServices.getMemberBanks().then(value => {
        commit('setloading', false)
        commit('setmemberbank', value)
      }).catch(reason => {
        console.log(reason)
        commit('setloading', false)
      })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  updateMemberbank ({ dispatch, commit }, data) {
    commit('setloading', true)
    MemberBankServices.updateMemberbank(data).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Update Bank Ok!', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  deleteMemberbank ({ dispatch, commit }, id) {
    commit('setloading', true)
    MemberBankServices.deleteMemberbank(id).then(value => {
      commit('setloading', false)
      dispatch('alert/success', 'Delete Bank Ok!', { root: true })
      dispatch('getMemberBanks')
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getOtpProfile ({ dispatch, commit }, phone) {
    commit('setloading', true)
    MemberBankServices.getOTPProfile(phone).then(value => {
      commit('setloading', false)
      commit('setotpkey', value)
      dispatch('alert/success', 'Otp Terkirim', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getOtp ({ dispatch, commit }) {
    commit('setloading', true)
    MemberBankServices.getOTP().then(value => {
      commit('setloading', false)
      commit('setotpkey', value)
      dispatch('alert/success', 'Otp Terkirim', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  doCashout ({ dispatch, commit }, data) {
    commit('setloading', true)
    MemberBankServices.doCashout(data).then(value => {
      commit('setloading', false)
      commit('setdialogcashout', false)
      dispatch('alert/success', 'Casout dalam proses..', { root: true })
      dispatch('authentication/getme', '', { root: true })
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
      dispatch('alert/error', reason, { root: true })
    })
  },
  getMemberBanksCashout ({ commit }, amount) {
    commit('setloading', true)
    MemberBankServices.getMemberBanksCashout(amount).then(value => {
      commit('setloading', false)
      commit('setbankavailablecashout', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  cleardata (state) {
    state.jmltopup = 0
    state.bankavailablecashout.ready = false
    state.bankavailablecashout.banks = []
    state.tiketdepositresponse = {}
  },
  setjmltopup (state, s) {
    state.jmltopup = s
  },
  setloading (state, s) {
    state.loading = s
    state.overlay = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  setdialogtopupsaldo (state, s) {
    state.dialogtopupsaldo = s
  },
  setdialogaddbank (state, s) {
    state.dialogaddbank = s
  },
  setdialogcashout (state, s) {
    state.dialogcashout = s
  },
  setdata (state, s) {
    state.kodepromo = []
    state.kodepromo = s.data.content
    state.totalkodepromo = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setpaymenthistories (state, s) {
    state.paymenthistories = []
    state.paymenthistories = s.data.content
    state.totalpaymenthistori = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setmutasisaldo (state, s) {
    state.mutasisaldo = []
    state.mutasisaldo = s.data.content
    state.totalmutasisaldo = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setmutasisaldodownload (state, s) {
    state.mutasisaldodownload = []
    state.mutasisaldodownload = s.data
    state.loading = false
    state.overlay = false
  },
  setpaymentmethod (state, s) {
    state.paymentmethod = []
    state.paymentmethod = s.data
    state.loading = false
    state.overlay = false
  },
  setmemberbank (state, s) {
    state.memberbanks = []
    state.memberbanks = s.data
    state.loading = false
    state.overlay = false
  },
  setinvoiceresponse (state, s) {
    state.invoiceccresponse = {}
    state.invoiceccresponse = s.data
    state.loading = false
    state.overlay = false
  },
  settiketdepositresp (state, s) {
    state.tiketdepositresponse = {}
    state.tiketdepositresponse = s.data
    state.loading = false
    state.overlay = false
  },
  setotpkey (state, s) {
    state.otpkey = ''
    state.otpkey = s.data
    state.loading = false
    state.overlay = false
  },
  setbankavailablecashout (state, s) {
    state.bankavailablecashout = s.data
    state.loading = false
    state.overlay = false
  },
  setpaymenthistoriesdownload (state, s) {
    state.paymenthistoriesdownload = s.data
    state.loading = false
    state.overlay = false
  }
}

export const SaldoStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
